import { render } from "./BtnPrimary.vue?vue&type=template&id=36b867b6"
import script from "./BtnPrimary.vue?vue&type=script&lang=js"
export * from "./BtnPrimary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__